// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms--terms--2uKHT"};